export default function NextButton({ pagination, loading, handlePageChange }) {
    return (
        <button
            onClick={() =>
                handlePageChange(pagination.current_page + 1)
            }
            disabled={
                loading || pagination.current_page === pagination.last_page
            }
        >
            Next
        </button>
    );
}
